// extracted by mini-css-extract-plugin
export default {"navContainer":"KjTS7XeWHYr_ljjnvnpK","innerWrapper":"KLrT_E3gTtgkiggQUivx","iconContainer":"tKV9xNDggrVgMct1_h6A","selected":"EPJFk5L1iDZb7OYMAuZN","icon":"sdQ4XxH0nUMRXLWydzoa"};